import { render } from "./AdSummary.vue?vue&type=template&id=25ab4374&scoped=true"
import script from "./AdSummary.vue?vue&type=script&lang=js"
export * from "./AdSummary.vue?vue&type=script&lang=js"

import "./AdSummary.vue?vue&type=style&index=0&id=25ab4374&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ab4374"]])

export default __exports__